import { ActionLink } from "./ActionLink";

export function HomePage({ locale, copy }) {
  const darkProducts = new Set(["gecko", "capture"]);

  return (
    <>
      <main>
        <section className="home-hero">
          <div className="hero-copy">
            <img
              className="hero-imajnet-logo"
              src="/media/imajnet-web-geo-services.png"
              alt="imajnet web geo services"
            />
            <h1 className="visually-hidden">{copy.heroTitle}</h1>
            <div className="hero-login">
              <ActionLink href="https://gecko.imajnet.net/" secondary>
                {copy.heroLogin}
              </ActionLink>
            </div>
          </div>
        </section>

        <section className="account-section" id="accounts">
          <div className="account-grid">
            {copy.accounts.map((account) => (
              <article
                className={`account-card${account.text ? "" : " account-card-compact"}`}
                key={account.title}
              >
                <h3>{account.title}</h3>
                {account.text ? <p>{account.text}</p> : null}
                <ActionLink href={account.href} secondary>
                  {account.label}
                </ActionLink>
              </article>
            ))}
          </div>
        </section>

        <section className="products" id="products">
          {copy.products.map((product, index) => (
            product.id === "sdk" ? (
              <article className="sdk-panel" id={product.id} key={product.id}>
                <div className="product-copy">
                  <img className="sdk-logo" src={product.image} alt="" />
                  <h3>{product.title}</h3>
                  <p>{product.text}</p>
                  <ActionLink href={product.href} secondary>
                    {product.label}
                  </ActionLink>
                </div>
              </article>
            ) : (
              <article
                className={`product-row${index % 2 ? " reverse" : ""}${
                  darkProducts.has(product.id) ? " dark" : ""
                }`}
                id={product.id}
                key={product.id}
              >
                <div
                  className="product-image"
                  style={{
                    backgroundImage: `url("${product.image}")`,
                    backgroundPosition: product.imagePosition,
                  }}
                  role="img"
                  aria-label=""
                />
                <div className="product-copy">
                  <p className="product-kicker">{product.eyebrow}</p>
                  <h3>{product.title}</h3>
                  <p>{product.text}</p>
                  {product.emphasis && <p className="emphasis">{product.emphasis}</p>}
                  <div className="button-row">
                    {product.links ? (
                      product.links.map((link) => (
                        <ActionLink
                          href={link.href}
                          key={link.href}
                          secondary
                        >
                          {link.label}
                        </ActionLink>
                      ))
                    ) : (
                      <ActionLink
                        href={product.href}
                        secondary
                      >
                        {product.label}
                      </ActionLink>
                    )}
                  </div>
                </div>
              </article>
            )
          ))}
        </section>
      </main>
      <span className="current-locale" aria-hidden="true">
        {locale}
      </span>
    </>
  );
}
